export default __webpack_public_path__ + "static/media/white_bishop.7fe341c5.png";